import React  from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import {RootState} from "store";

const PublicRoute = () => {

	const { auth_token } = useSelector((state: RootState) => state.auth);
  
	return auth_token
		? <Navigate to={AUTHENTICATED_ENTRY} />
		: <Outlet/>;
};

export default PublicRoute;